import React, { useEffect, useState, useRef } from 'react';
import FeaturedCard from './featuredcard';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

// Translation keys that need to be added to translation files:
// review.website = "Website Reviews" 
// review.google = "Google Reviews"

const ReviewSection = () => {
    const { t } = useTranslation();
    const [reviewType, setReviewType] = useState('all');
    const [googleReviews, setGoogleReviews] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const mapScriptLoaded = useRef(false);
    
    // API key and Place ID for Cappadocia Visitor
    const API_KEY = 'AIzaSyA_tKbW6A5pQ-eupxI56myUnHLqYCzOjKo'; // Gerçek API anahtarınızla değiştirin
    const PLACE_ID = 'ChIJ8bfaJpZgWxQRXJYp1DC7cBo'; // İşletmenizin Place ID'si ile değiştirin
    
    // Google Maps API callback function
    const setupGoogleMapsCallback = () => {
        // Global callback function for the Google Maps API
        window.initGoogleReviews = () => {
            mapScriptLoaded.current = true;
            loadGoogleReviews();
        };
    };
    
    // Function to fetch Google reviews using Places API
    const loadGoogleReviews = () => {
        if (!window.google || !window.google.maps || !window.google.maps.places) {
            console.error('Google Maps Places API not loaded yet');
            return;
        }
        
        setIsLoading(true);
        
        try {
            const service = new window.google.maps.places.PlacesService(
                document.createElement('div')
            );
            
            service.getDetails(
                {
                    placeId: PLACE_ID,
                    fields: ['name', 'rating', 'reviews']
                },
                (place, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && place && place.reviews) {
                        setGoogleReviews(place.reviews);
                    } else {
                        console.error('Error loading Google reviews:', status);
                    }
                    setIsLoading(false);
                }
            );
        } catch (error) {
            console.error('Error in Google Places API:', error);
            setIsLoading(false);
        }
    };
    
    // Set up once at component mount
    useEffect(() => {
        // Set up API callback
        setupGoogleMapsCallback();
        
        // If Google Maps is already loaded, get reviews
        if (window.google && window.google.maps && window.google.maps.places) {
            loadGoogleReviews();
        }
        
        return () => {
            // Clean up
            window.initGoogleReviews = undefined;
        };
    }, []);
    
    // Process Google reviews to match the card component format
    const processedGoogleReviews = googleReviews.map(review => ({
        id: `google-${review.time}`,
        full_name: review.author_name || 'Google User',
        comment: review.text || '',
        item_name: 'Cappadocia Visitor',
        type: 'google',
        featured_image: review.profile_photo_url || 'https://www.gstatic.com/images/branding/product/2x/googleg_48dp.png',
        rate: review.rating || 5
    }));
    
    // Filter reviews based on selected type
    const displayedReviews = () => {
        if (reviewType === 'google' || reviewType === 'all') {
            return processedGoogleReviews;
        }
        return [];
    };
    
    const handleChangeReviewType = (e) => {
        setReviewType(e.target.value);
    };

    if (isLoading) {
        return <div className="text-center py-5"><div className="spinner-border text-primary" role="status"></div></div>;
    }

    return (
        <div className='reviewSection'>
            {/* Load Google Maps API with Places library */}
            <Helmet>
                <script 
                    src={`https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&callback=initGoogleReviews`}
                    async 
                    defer
                />
            </Helmet>
            
            <div className='bgblue w-100 ps-md-1'>
                <div className='d-flex justify-content-between align-items-center blogSectionMain mediaQueryPadding  pt-0 pb-0'>
                    <div>
                        <h1 className='text-white baslik1 p-md-5 ps-0 '>{t('review.review')}</h1>
                    </div>

                    <div className='d-flex justify-content-center align-items-center pe-md-5'>
                        <div className='w-100'>
                            <div className='text-white pb-2'>
                            {t('review.commentType')}
                            </div>
                            <select className='whiteborderinput' value={reviewType} onChange={handleChangeReviewType}>
                                <option value="all">{t('review.all')}</option>
                                <option value="google">{t('review.google')}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blogSectionMain mediaQueryPadding pt-5 pb-5">
                <div className='blogGrid'>
                    {displayedReviews().map((item, index) => (
                        <div key={item.id || index} className='reviewCard'>
                            <FeaturedCard
                                commentUser={item.full_name}
                                content={item.comment}
                                commentName={item.item_name}
                                commentType={item.type}
                                image={item.featured_image}
                                star={item.rate}
                                type="review"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ReviewSection